import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsToeKickType = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.dimensions.toeKickType;

export const toeKickType = setCalculationModeAdminSettingsToeKickType(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_TOE_KICK_TYPE',
  'toFloor'
);
